"use client";

import { createUrlWithSearchParams } from "@/shared/libs/url-utils";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback, useMemo } from "react";
import Flex from "../../common/Flex";
import List from "../../common/List";
import Typography from "../../common/Typography";
import staticData from "@/public/data/components/filter.json";
import { X } from "@phosphor-icons/react";
import PhosphorIcon from "../../common/PhosphorIcon";

export default function FilterChipList() {
  const pathName = usePathname();
  const params = useSearchParams();

  const { replace } = useRouter();

  const FILTERS = useMemo(() => {
    const ACTIVE_FILTERS: {
      name: string;
      label: string;
      id: string;
    }[] = [];

    for (const chip of staticData.chips) {
      const value = params.get(chip.name);
      if (value) ACTIVE_FILTERS.push(chip);
    }

    return ACTIVE_FILTERS;
  }, [params]);

  const handleChangeFilter = useCallback(
    (key: string) => () => {
      const searchParams = new URLSearchParams(params.toString());

      searchParams.delete(key);
      replace(createUrlWithSearchParams(pathName, searchParams));
    },
    [params, pathName, replace],
  );

  return (
    <Flex
      alignItems={"center"}
      justifyContent={"end"}
      gap={"2"}
      wrap={"wrap"}
      className="basis-1/2"
    >
      <List
        items={FILTERS}
        renderItems={({ name, label }) => (
          <Flex.Item
            className="p-1 px-2 rounded-full bg-background ring-1 ring-border cursor-pointer group hover:ring-ring transition duration-100 ease-in-out"
            onClick={handleChangeFilter(name)}
          >
            <Flex alignItems={"center"} gap={"3"}>
              <Flex.Item>
                <Typography variant={"body2"}>{label}</Typography>
              </Flex.Item>
              <Flex.Item className="bg-muted rounded-full p-1 hover:text-foreground transition duration-100 ease-in-out">
                <PhosphorIcon
                  name="X"
                  weight="bold"
                  size={15}
                  className="text-muted-foreground"
                />
              </Flex.Item>
            </Flex>
          </Flex.Item>
        )}
      />
    </Flex>
  );
}
